module.exports = __webpack_public_path__ + "static/media/dr-bourriez.2c0e6e27.jpg";